import React, { FC } from 'react';
import { useButton, useI18n } from '~Hooks';
import { Box, GreenButton, GhostButton } from '~Styles';
import ErrorNote from '~Components/ErrorNote';

interface Props {
  /** Shown above the question, e.g. when the last answer could not be saved. */
  notice?: string;
  /** True when reception found the bill on the room. */
  onAnswer: (onFolio: boolean) => void;
  onCancel: () => void;
}

/**
 * The hotel did not answer, so the bill may already be on the room. No other
 * payment is offered until staff have checked with reception.
 */
const UnconfirmedStep: FC<Props> = ({ notice, onAnswer, onCancel }) => {
  const { i18n } = useI18n();
  const yesButton = useButton({ onClick: () => onAnswer(true) });
  const noButton = useButton({ onClick: () => onAnswer(false) });
  const cancelButton = useButton({ onClick: onCancel });

  return (
    <Box fluid display="flex" flexDirection="column" gap="medium">
      {notice && <ErrorNote>{notice}</ErrorNote>}
      <ErrorNote>{i18n('HotelRoom.Unconfirmed')}</ErrorNote>

      <Box fluid style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <GhostButton {...noButton} size="large">
          {i18n('HotelRoom.NotOnTheRoom')}
        </GhostButton>
        <GreenButton {...yesButton} size="large">
          {i18n('HotelRoom.OnTheRoom')}
        </GreenButton>
      </Box>
      <GhostButton {...cancelButton} size="large">
        {i18n('HotelRoom.Cancel')}
      </GhostButton>
    </Box>
  );
};

export default UnconfirmedStep;
